module.exports = __webpack_public_path__ + "index.html";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=index.html!./src/index.html
// module id = 281
// module chunks = 0